/*       */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { baseRoutes } from 'app/config/routesConfig';

import Link from 'app/components/atoms/Link/Link';

const ScriptLink = props => {
    const { id, children, path, noDecoration, ...restProps } = props;
    const tab = path ? `/${path}` : '';
    return (
        <Link to={`${baseRoutes['script']}/${id}${tab}`} noDecoration={noDecoration} {...restProps}>
            {children}
        </Link>
    );
};

ScriptLink.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    noDecoration: PropTypes.bool,
    children: PropTypes.node,
};

export default memo(ScriptLink);
